import type { FaireProductEntity } from "../../entity_types/product";

export const p_jbagyns275: FaireProductEntity = {
  token: "p_jbagyns275",
  type: "product",
  name: "Cloud II™ Classic Bra - Oxford",
  brandToken: "b_qa8gaqqvwt",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/cf9cfef89abb477c23eec5c02819d5d589cce23c25161c88624da4cf31c5294c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/abb905be15966cdb49dfb5aa2e96b608fca1835dd053b54839d99792a830c37c.jpeg",
    "https://cdn.faire.com/fastly/e8b1ba2c52ab4d68ccd18bcc18128da515d0f9c59395bd886e92cc7e31621593.jpeg",
    "https://cdn.faire.com/fastly/30f3f7d704a8e5948dac492f60164613db000aaa24431c9d70d27e8e487ee83a.jpeg",
    "https://cdn.faire.com/fastly/a5f8773af6dee46b5f07f61c657c348f016914176b06d5a1d6fc57ba5d62d6fc.jpeg",
  ],
  priceDollars: 47,
  description:
    "At first glance, our Cloud II Classic Bra may seem like a simple scoop-neck sports bra. The signature Cloud II fabric is buttery soft with perfectly balanced stretch and compression and advanced performance tech, so she's comfy enough for everything from coffee runs to the sweatiest gym sesh. But a closer look reveals a subtle design twist: adjustable shoulder straps that connect at the back rather than in the front, giving a sleeker, cleaner, more refined finish. ",
  tags: [],
  msrpDollars: 94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:53.561Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
